import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum TaskStatusId {
  OPEN = 1,
  RESOLVED = 2,
  IN_PROGRESS = 3,
}

export class TaskStatus extends Codebook<TaskStatusId> {
  static readonly OPEN = new TaskStatus(TaskStatusId.OPEN, () => $t('taskStatus.open'), Color.INFO)
  static readonly IN_PROGRESS = new TaskStatus(
    TaskStatusId.IN_PROGRESS,
    () => $t('taskStatus.inProgress'),
    Color.WARNING,
  )
  static readonly RESOLVED = new TaskStatus(
    TaskStatusId.RESOLVED,
    () => $t('taskStatus.resolved'),
    Color.POSITIVE,
  )

  private constructor(
    public readonly id: TaskStatusId,
    public readonly name: () => string,
    public readonly color: Color.POSITIVE | Color.WARNING | Color.INFO,
  ) {
    super(id)
  }
}
